import type { App } from '@grafikr/components';
import header from 'layout/header';

import hasUrlParam from 'utils/loaders/has-url-param';
import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import onEvent from 'utils/loaders/on-event';

export default (app: App) => {
  app.add({
    // Layout
    header,
    'header-drawer-navigation': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "layout-header-drawer-navigation" */ 'layout/header-drawer-navigation'
        ),
    ],

    // Components
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    announcements: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-announcements" */ 'components/announcements'),
    ],
    carousel: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-carousel" */ 'components/carousel'),
    ],
    'cart-count': [
      onEvent,
      () => import(/* webpackChunkName: "component-cart-count" */ 'components/cart-count'),
    ],
    'cart-drawer': [
      [onElementInteraction, hasUrlParam, ...(theme.pageType !== 'cart' ? [onEvent] : [])],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    drawer: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-drawer" */ 'components/drawer'),
    ],
    accordion: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-accordion" */ 'components/accordion'),
    ],
    'read-more': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-read-more" */ 'components/read-more'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    pagination: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-pagination" */ 'components/pagination'),
    ],
    'search-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-search-drawer" */ 'components/search-drawer'),
    ],
    'sort-by': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-sort-by" */ 'components/sort-by'),
    ],
    'placeholder-image': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "components-placeholder-image" */ 'components/placeholder-image'
        ),
    ],
    subdrawer: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-subdrawer" */ 'components/subdrawer'),
    ],
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    'product-wishlist-button': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-wishlist-button" */ 'components/product-wishlist-button'),
    ],
    'clerk-recommendations': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-clerk-recommendations" */ 'components/clerk-recommendations'),
    ],
    'clerk-search-results': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-clerk-search-results" */ 'components/clerk-search-results'),
    ],
    'clerk-collection-page': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-clerk-collection-page" */ 'components/clerk-collection-page'),
    ],
    'wishlist-count': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-wishlist-count" */ 'components/wishlist-count'),
    ],

    // Pages
    cart: [intersectionLoader, () => import(/* webpackChunkName: "cart-main" */ 'pages/cart/main')],
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    'product-linked': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-linked" */ 'pages/product/linked'),
    ],
    'product-media': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-media" */ 'pages/product/media'),
    ],
    wishlist: [
      intersectionLoader,
      () => import(/* webpackChunkName: "wishlist-main" */ 'pages/wishlist/main'),
    ],
  });
};
